const BROKER_ACCESS_LEVELS = new Set([
  "broker",
  "covomo",
  "insurance-intermediate",
  "pool",
  "ref",
  "ref-broker",
  "software",
]);

export const isBrokerAccessLevel = (accessLevel: string) => {
  return BROKER_ACCESS_LEVELS.has(accessLevel);
};

const hasValue = (value: unknown): boolean => {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) {
    return value.some((v) => hasValue(v));
  }
  return String(value).trim() !== "";
};

export const hasAffiliateSignal = (
  affiliateData?: Record<string, unknown>,
): boolean => {
  if (!affiliateData || typeof affiliateData !== "object") {
    return false;
  }

  return (
    hasValue(affiliateData.affiliate_id) ||
    hasValue(affiliateData.a) ||
    hasValue(affiliateData.r) ||
    hasValue(affiliateData.ref)
  );
};

/** Calculator affiliate id from `r` payload (`affiliate_id`, else legacy `a`). */
export const getCalculatorAffiliateId = (
  affiliateData?: Record<string, unknown>,
): string => {
  if (!affiliateData || typeof affiliateData !== "object") {
    return "";
  }
  const id = affiliateData.affiliate_id;
  if (hasValue(id)) {
    return String(Array.isArray(id) ? id[id.length - 1] : id).trim();
  }
  const a = affiliateData.a;
  if (hasValue(a)) {
    return String(Array.isArray(a) ? a[a.length - 1] : a).trim();
  }
  return "";
};

/**
 * When the Vertriebsportal cookie names a different affiliate than the
 * calculator link, the logged-in broker must not be treated as closing broker.
 */
export const portalAffiliateMatchesCalculator = (
  portalAffiliateId: string | undefined | null,
  affiliateData?: Record<string, unknown>,
): boolean => {
  const portalId = String(portalAffiliateId || "").trim();
  if (!portalId) {
    return true;
  }
  const calcId = getCalculatorAffiliateId(affiliateData);
  if (!calcId) {
    return true;
  }
  return portalId === calcId;
};

export const getCompletedBy = (
  affiliateData: Record<string, unknown> | undefined,
  accessLevel: string,
  fromPortal?: boolean,
  portalAffiliateId?: string | null,
): "broker" | "end_customer" => {
  const affiliateSignal = hasAffiliateSignal(affiliateData);

  if (!affiliateSignal) {
    return "end_customer";
  }

  if (!portalAffiliateMatchesCalculator(portalAffiliateId, affiliateData)) {
    return "end_customer";
  }

  const hasBrokerContext =
    Boolean(fromPortal) || isBrokerAccessLevel(accessLevel);

  return hasBrokerContext ? "broker" : "end_customer";
};
